module.exports = __webpack_public_path__ + "img/准确、⾼效、易⽤的决策分析支撑.9199d08e.png";